module.exports = __webpack_public_path__ + "img/trial2-4.f7ba7c89.png";